"use strict";
exports.__esModule = true;
exports.createTimeout = void 0;
function createTimeout(op, duration) {
    var id = setTimeout(op, duration);
    return function () { return clearTimeout(id); };
}
exports.createTimeout = createTimeout;
